import { create } from "zustand";
import { VesselStatus } from "~/utils/constants";

type State = {
  formState: {
    open: boolean;
    vesselId?: string;
  };
  listState: "vessels" | "shuttles";
  filters: TVesselFilters;
};

type TVesselFilters = {
  vesselStatus: VesselStatus | null;
  vesselTypeId: string | null;
  search: string;
  page: number;
  pageSize: number;
};

type Actions = {
  setFilters: (filters: Partial<TVesselFilters>) => void;
  resetFilters: () => void;
  openVesselModal: (vesselId?: string) => void;
  closeVesselModal: () => void;
  setListState: (listState: "vessels" | "shuttles") => void;
};

const initialState: TVesselFilters = {
  vesselStatus: "" as VesselStatus,
  vesselTypeId: "",
  search: "",
  page: 1,
  pageSize: 10,
};

export const useVesselStore = create<State & Actions>()((set) => ({
  formState: {
    open: false,
  },
  listState: "vessels",
  filters: initialState,
  setFilters: (filters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  resetFilters: () => set({ filters: initialState }),
  openVesselModal: (vesselId) =>
    set({
      formState: {
        open: true,
        vesselId,
      },
    }),
  closeVesselModal: () =>
    set({ formState: { open: false, vesselId: undefined } }),
  setListState: (listState) =>
    set(() => ({
      listState,
    })),
}));
